import application from 'application/application';

application

	.run(['$rootScope', '$http', '$transitions', '$state', 'authentication', 're', 'helper', 'API', 'templates', 'environment', 'HttpPendingRequestsService', 'transformDate', ($rootScope, $http, $transitions, $state, authentication, re, helper, API, templates, environment, HttpPendingRequestsService, transformDate) => {

		/** Recuperar dados do usuário */
		$rootScope.re = re;

		$transitions

			.onStart(null, transition => {
				if (window.location.href.indexOf('access_token?=') > -1)
					localStorage.clear();

				let stateService = transition.router.stateService;

				if (!authentication.isLogged() && transition.params().authentication) {

					transition.abort();

					stateService.go('root.login');

				} else if (transition.to().name === 'root.default.initial') {

					transition.abort();

					stateService.go('root.default.movements.list');

				}

				/** Limpa as configurações de alertas de confirmação ao fechar. */
				$('#modalAlert')

					.off('hidden.bs.modal')

					.on('hidden.bs.modal', () => {

						delete $rootScope.documentAlertStyle;

						delete $rootScope.documentAlertTitle;

						delete $rootScope.documentAlertButtons;

					});

				$('.busy-overlay').addClass('open');

			});

		$transitions.onFinish(null, () => $('.busy-overlay').removeClass('open'));

		$rootScope.signOut = stateName => {

			$rootScope.removeAllStorageInfo();

			$('.modal').modal('hide');

			$state.go(stateName || 'root.login');

		};

		$rootScope.removeAllStorageInfo = () => {

			Object.keys(localStorage)

				.forEach(value => /^__authentication\w+__$/i.test(value) && localStorage.removeItem(value));

			localStorage.removeItem('__hasGroup__');
			localStorage.removeItem('__groupUserData__');
			localStorage.removeItem('__groupSelected__');

		};

		$rootScope.callLoginModal = () => {

			$rootScope.removeAllStorageInfo();

			$('#modalQuickLogin').modal('show');

		};

		$transitions

			.onBefore (null, transition => {
				return transition;
			});

		$transitions

			.onSuccess(null, transition => {
				let { data } = transition.to();

				$rootScope.data = data;
				$rootScope.$state = transition;
				clearInterval($rootScope.authenticationCheckTimer);
				$rootScope.authenticationCheckTimer = setInterval(() => {
					if (!authentication.isLogged() && localStorage.getItem('__authenticationToken__')) {
						let callingRefreshToken = localStorage.getItem('__authenticationCallingRefreshToken__'),
							refreshToken = localStorage.getItem('__authenticationRefreshToken__');

						if (refreshToken && refreshToken != 'undefined' && callingRefreshToken !== 'true')
						{
							localStorage.setItem('__authenticationCallingRefreshToken__', true);
							$http({
								...helper.http(API.refreshToken, 'POST'),
								data: {
									'grant_type': 'refresh_token',
									'refresh_token': localStorage.getItem('__authenticationRefreshToken__')
								},
								messageOverride: {
										error() {}
									}
							})
								.then(response => {
									let { data } = response,
										callbackFunction = () => {
											localStorage.setItem('__authenticationCallingRefreshToken__', false);
										};

									transformDate.formatDate(response.data.expires_in);

									authentication.signIn(data, callbackFunction);
									localStorage.setItem('__authenticationUserImage__', data.foto);
								}, () => {
									localStorage.clear();
									$('.modal').modal('hide');
									$rootScope.callLoginModal();
								})
								.finally(() => $('.busy-overlay').removeClass('open'));
						}
						else if (callingRefreshToken !== 'true')
						{
							localStorage.clear();
							$('.modal').modal('hide');
							$rootScope.callLoginModal();
						}
					}
				}, 1000);
				$('[autofocus]:first').trigger('focus');

				HttpPendingRequestsService.cancelAll();
			});


		$rootScope.appTemplate = id => templates[id ? id : authentication.getUserData('idProdutoAdvise')];

		$rootScope.closeNavMobile = () => {
			$('.nav-icons-item').on('click', function() {
				$('.navbar-collapse').collapse('hide');
			});
		};

		$rootScope.attentionMsg = false;

		$rootScope.blockedUser = false;

		$rootScope.openZendesk = () => environment.name === 'production' ? zE.activate({ hideOnClose: true }) : null;

		$rootScope.getTemplate = (templates, id) => templates[id];
	}]);
